import React from "react";
import config from "../config";

import WorkingIndicator from "./partials/working-indicator.jsx";

import connectToStores from "alt-utils/lib/connectToStores";
import UserStore from "../stores/UserStore";

class Account extends React.Component {
  constructor(props) {
    super(props);
    this.getScannerImgUrl = this.getScannerImgUrl.bind(this);
  }

  static getStores() {
    return [UserStore];
  }

  static getPropsFromStores() {
    return UserStore.getState();
  }

  static get contextTypes() {
    return {
      router: React.PropTypes.object
    };
  }

  getScannerImgUrl() {
    let url = `${config.endpoint}users/self/api_keys/qr.svg?api_key=${this.props.apiKey}&scope=ticket-scanner`;
    if (UserStore.isGod()) {
      url += "&god_become_user=" + UserStore.getGodCredentials().activeUser;
    }
    return url;
  }

  getStyles() {
    return {
      body: {
        fontSize: "12pt"
      },
      image: {
        width: "100%",
        maxWidth: 250,
        border: "1px solid #ccc"
      }
    };
  }

  render() {
    var styles = this.getStyles();

    if (!this.props.apiKey) {
      return <WorkingIndicator fullPage={true} />;
    }

    return (
      <div>
        <h1>Eventive Scanner</h1>
        <p style={styles.body}>
          Eventive Scanner is a mobile application (iOS and Android) that allows you to quickly and
          easily scan and sell tickets and passes at the door.
          <br />
          <a href="https://help.eventive.org/en/articles/892280-eventive-scanner" target="_blank">
            Learn more about Eventive Scanner.
          </a>
        </p>
        <h2>Using Eventive Scanner</h2>
        <p style={styles.body}>
          We offer a{" "}
          <a
            href="https://help.eventive.org/eventive-scanner/introducing-eventive-scanner"
            target="_blank"
          >
            dedicated scanner for rent
          </a>{" "}
          to meet your festival's needs.
          <br />
          You can also install our free standalone iOS or Android application for use on an
          unlimited number of devices.
        </p>
        <p style={styles.body}>
          <a
            href="https://itunes.apple.com/US/app/id1052529739?mt=8"
            target="_blank"
          >
            <img src="/img/download-on-app-store.svg" />
          </a>
          <a
            href="https://play.google.com/store/apps/details?id=org.eventive.scanner"
            target="_blank"
          >
            <img src="/img/download-on-google-play.png" style={{ paddingLeft: 15, width: 135 }}/>
          </a>
        </p>
        <h2>Authentication QR code for {this.props.data.owner.organization}</h2>
        <p style={styles.body}>
          After installing the app, just scan the code below to login as{" "}
          {this.props.data.owner.organization}.
        </p>
        <img style={styles.image} src={this.getScannerImgUrl()} />
      </div>
    );
  }
}

export default connectToStores(Account);



// WEBPACK FOOTER //
// ./src/app/components/scanner-setup.jsx